export default "__VITE_ASSET__1f4efe8b__"